import { render, staticRenderFns } from "./ReqBillingItemsTable.vue?vue&type=template&id=04c601c7"
import script from "./ReqBillingItemsTable.vue?vue&type=script&lang=js"
export * from "./ReqBillingItemsTable.vue?vue&type=script&lang=js"
import style0 from "./ReqBillingItemsTable.vue?vue&type=style&index=0&id=04c601c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports